import { useState, useEffect } from 'react';
import Content from './components/content/Content';
import Load from './components/load/Load';
import './App.css';
import AppProvider from './context/AppProvider';

function App() {

  const [theme, setTheme] = useState('');
  const [icon, setIcon] = useState('');

  useEffect(() => {
    if(!localStorage.getItem("theme") || localStorage.getItem("theme") === 'undefined'){
      localStorage.setItem("theme", "mode_light");
      setTheme(localStorage.getItem("theme"));
      setIcon('light');
      return;
    }
    else{
      setTheme(localStorage.getItem("theme"));
      if(localStorage.getItem("theme") === 'mode_light'){
        setIcon('light');
      }
      else{
        setIcon('dark');
      }
      return;
    }
  }, []);

  return (
    <AppProvider>
      <div className={(theme === 'modo_light') ? "App" : `App ${theme}`}>
        <Load />
        <Content isIcon={icon} isSetIcon={setIcon} isTheme={theme} isSetTheme={setTheme} />
      </div>
    </AppProvider>
    
  );
}

export default App;
